module.exports = __webpack_public_path__ + "img/东海鲐鱼渔场预报系统.1ead141c.png";